module.exports = __webpack_public_path__ + "img/DJ.37b73436.svg";